const DEFAULT_CLASSNAMES = {
  container: "flex justify-center items-center gap-2",
  spinner:
    "shadow animate-spin border-dashed rounded-full h-6 w-6 border-2 border-white",
  text: "text-white",
};

const Spinner = ({ classNames = DEFAULT_CLASSNAMES }) => {
  return (
    <div className={classNames?.container || DEFAULT_CLASSNAMES.container}>
      <div className={classNames?.spinner || DEFAULT_CLASSNAMES.spinner}></div>
      {/* <span className={classNames?.text || DEFAULT_CLASSNAMES.text}>
        loading...
      </span> */}
    </div>
  );
};

export default Spinner;
